intra_module.controller('ChangelogCtrl', function($scope, $uibModalInstance) {
	$scope.changelog = "";
	$scope.loading = true;

	fetch('templates/changelog.md').then(function(response) {
		return response.text();
	}).then(function(content) {
		$scope.changelog = content;
		$scope.$apply();
	}).catch(function(err) {
		$scope.content = "Cannot fetch changelog: " + err;
	}).finally(function() {
		$scope.loading = false;
	});;
	
	$scope.cancel = () => $uibModalInstance.dismiss('cancel');
});
